import React from 'react'
import PropTypes from 'prop-types'
import { US_STATES, US_STATES_WITH_NA } from '../../../../constant/US_STATES'
import RegisteredFormField from '../../../common/RegisteredFormField'
import ControlledFormField from '../../../common/ControlledFormField'

const StateSelectFormField = ({
  path,
  id,
  withNA,
  label,
  value,
  onChange = null,
  disabled = false
}) => {
  return onChange ?
    <ControlledFormField
      inputType='select'
      id={id}
      label={label}
      placeholder='Select a State'
      options={withNA ? US_STATES_WITH_NA : US_STATES}
      value={value}
      onChange={onChange}
      disabled={disabled}
    /> :
    <RegisteredFormField
      inputType='select'
      path={path}
      id={id}
      label={label}
      placeholder='Select a State'
      options={withNA ? US_STATES_WITH_NA : US_STATES}
      disabled={disabled}
    />
}

StateSelectFormField.propTypes = {
  /** The redux object full path for this form field */
  path: PropTypes.string,
  /** A unique element ID */
  id: PropTypes.string,
  /** Whether the select options should include "N/A" as a State */
  withNA: PropTypes.bool,
  /** A label for this form field */
  label: PropTypes.node,
  /** A controlled State Select field should have a value passed into it */
  value: PropTypes.string,
  /** A controlled State Select field should have an onChange callback function¬ passed into it */
  onChange: PropTypes.func,
  /** Should input disable for user input */
  disabled: PropTypes.bool
}

export default StateSelectFormField